const stateGenerator = {
  generateInitialState(itemsPerPage = 0){
    return {
      // Query Redux Initial State
      query: {},
      defaultQuery: {
        limit: itemsPerPage,
        offset: '0'
      },
    }
  }
}

export default stateGenerator
